import { Alert, IconButton, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useToastStore } from "@/core/stores/useToastStore";

const TOAST_OFFSET_PX = 64;

export function ToastHost(): React.ReactElement {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <>
      {toasts.map((toast, index) => (
        <Snackbar
          key={toast.id}
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{ transform: `translateY(-${String(index * TOAST_OFFSET_PX)}px)` }}
          onClose={() => {
            dismiss(toast.id);
          }}
        >
          <Alert
            severity={toast.severity}
            variant="filled"
            sx={{ width: "100%" }}
            action={
              <IconButton
                size="small"
                aria-label="Dismiss"
                color="inherit"
                onClick={() => {
                  dismiss(toast.id);
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            {toast.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}
